import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getDefaultDashboardSelector } from '../../../../../redux/reducers/reducerSlices/DefaultDashboardReducer';
import Header from '../../../Header/Header';
import Navigationbar from '../../../Navigationbar/Navigationbar';
import DefaultDashboardWrapper from '../../Components/Dashboard/DefaultDashboard/Wrapper/DefaultDashboardWrapper';
import PODockStatusFilter from '../../Components/POFilters/PODockStatusFilter/PODockStatusFilter';
import CustomDashboard from '../../Components/Dashboard/CustomDashboard/CustomDashboardWrappper';
import _  from 'lodash';
import './Dashboard.css';
import { getUserSelector } from '../../../../../redux/reducers/reducerSlices/UserReducer';
import { shouldHavePermission } from '../../../../Assests/Utility';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../../sagas/sagaActions';
import { getSelectedDockFilterListSelector } from '../../../../../redux/reducers/reducerSlices/FiltersReducerSlice';
import { getDockListSelector } from '../../../../../redux/reducers/reducerSlices/DockListReducer';
import { createDocksIdArr } from '../../Components/POFilters/FilterUtilities';

const Dashboard = (props) => {
    const { themeSelected } = props;
    const defaultDashboard = useSelector(getDefaultDashboardSelector);
    const { dashboardType } = defaultDashboard;
    const userPermission = useSelector(getUserSelector);
    const { permissions } = userPermission;
    const [allowPermissionD, setAllowPermissionD] = useState(false)
    const [allowPermissionC, setAllowPermissionC] = useState(false)
    const dispatch = useDispatch()
     const selectedDockFiltersList = useSelector(getSelectedDockFilterListSelector);
        const getDockList = useSelector(getDockListSelector);
        const { dockList } = getDockList;
        const [dockIdArr, setDockIdArr] = useState([]);
        
    useEffect(() => {
        dispatch({ type: sagaActions.CLEAR_FILTERS });
        dispatch({ type: sagaActions.RESET_TRUCK_DATA })
        dispatch({ type: sagaActions.RESET_ANALYTICS })
        dispatch({ type: sagaActions.SET_TASK_ITEM, payload: null });
        dispatch({ type: sagaActions.TASK_ITEM_DUE_SELECTED_DOCK_LIST, payload: [] })
        dispatch({ type: sagaActions.DRILLDOWN_SELECTED_DOCK_LIST, payload: [] })
        setDockIdArr([]); 
        if(permissions.length){
            const warehouseManagementPermission = _.find(permissions, { 'FeatureID': '8', 'PageAccess': true });
            if(warehouseManagementPermission && !_.isEmpty(warehouseManagementPermission)){
                setAllowPermissionD(true);
                setAllowPermissionC(true);
            }else{
                let tempD = shouldHavePermission(permissions, '601')
                setAllowPermissionD(tempD);
                let tempC = shouldHavePermission(permissions, '602')
                setAllowPermissionC(tempC);
            }            
        }
        dispatch({ type: sagaActions.FETCH_TRUCK_LIST, payload: '' })

        return () => {
            // dispatch({ type: sagaActions.CLEAR_FILTERS });
            // dispatch({ type: sagaActions.RESET_TRUCK_DATA })
            // dispatch({  type: sagaActions.RESET_ANALYTICS})

            dispatch({ type: sagaActions.CLEAR_FILTERS });
            dispatch({ type: sagaActions.RESET_TRUCK_DATA })
            dispatch({ type: sagaActions.RESET_ANALYTICS })
            dispatch({type: sagaActions.UPDATE_SELECTED_BUTTON, payload: { key: 'isWorkDay', loadStr: true }})

            // dispatch({ type: sagaActions.SET_TASK_ITEM, payload: null });
            // dispatch({ type: sagaActions.TASK_ITEM_DUE_SELECTED_DOCK_LIST, payload: [] })
            // dispatch({ type: sagaActions.DRILLDOWN_SELECTED_DOCK_LIST, payload: [] })
            // setDockIdArr([]); 
        }

    }, [])

      useEffect(() => {
            if (selectedDockFiltersList.length) {
                const updatedDockIdArr = createDocksIdArr(selectedDockFiltersList, dockList, false);
                setDockIdArr(updatedDockIdArr);
                // dockIdArrRef.current = updatedDockIdArr;
                // const updatedDockIdArrDrillDown = createDocksIdArr(selectedDockFiltersList, dockList, true);
                dispatch({ type: sagaActions.DRILLDOWN_SELECTED_DOCK_LIST, payload: updatedDockIdArr })
                
            } else {
                setDockIdArr([])
                // dockIdArrRef.current = [];
                dispatch({ type: sagaActions.DRILLDOWN_SELECTED_DOCK_LIST, payload: [] })
            }
        }, [selectedDockFiltersList])
    
    // useEffect(() => {
    //     dispatch({ type: sagaActions.CLEAR_FILTERS });
    //     dispatch({ type: sagaActions.RESET_TRUCK_DATA })
    //     dispatch({ type: sagaActions.RESET_ANALYTICS })
    //     dispatch({ type: sagaActions.SET_TASK_ITEM, payload: null });
    //     dispatch({type: sagaActions.TASK_ITEM_DUE_SELECTED_DOCK_LIST, payload: []})
    // }, [dashboardType])
    
    return (
        <div className='container-fluid executor'>
            <Header {...props} />
            <Navigationbar {...props}/>
            <PODockStatusFilter themeSelected={themeSelected} showOnlyDockFilters={true} showDashboardBtn={true} allowPermissionD={allowPermissionD} allowPermissionC={allowPermissionC} />
            {
                dashboardType === 'Default' ? <DefaultDashboardWrapper themeSelected={themeSelected} dockIdArr={ dockIdArr} /> :
                    <CustomDashboard themeSelected={themeSelected} />
            }
        </div>
    )
}

export default Dashboard;